import { RequestService } from '../../../../../common/services/RequestService';
import { API_PROFILE, MONITORING_PROFILE } from '../../constants';
import { adjustEditProfileData } from './adjustEditProfileData';

export const getProfileRequest = payload => {
  return RequestService.get(API_PROFILE + '/' + payload);
};

export const editProfileRequest = (payload, roleId) => {
  let obj = roleId ? { ...payload.data, roleId } : payload.data;
  return RequestService.put(
    API_PROFILE + '/' + payload.profileId + '/update_and_fill',
    adjustEditProfileData(obj)
  );
};
export const profileMonitoring = payload => {
  return RequestService.get(MONITORING_PROFILE + payload);
};
